import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { updateLoanData } from '../../../actions/refiApplicationActions'
import { selectLoanData } from '../../../reducers/refiApplication'

interface ApplicantInfoComponentProps {
  vehicle?: any
  user?: any
}

const ApplicantInfoComponent: React.FC<ApplicantInfoComponentProps> = ({ vehicle, user }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const savedLoanData = useSelector(selectLoanData)

  const [formData, setFormData] = useState({
    monthlyPayment: savedLoanData.monthlyPayment || '',
    currentLender: savedLoanData.currentLender || '',
    estimatedPayoff: savedLoanData.estimatedPayoff || ''
  })

  useEffect(() => {
    if (savedLoanData.monthlyPayment || savedLoanData.currentLender || savedLoanData.estimatedPayoff) {
      setFormData({
        monthlyPayment: savedLoanData.monthlyPayment || '',
        currentLender: savedLoanData.currentLender || '',
        estimatedPayoff: savedLoanData.estimatedPayoff || ''
      })
    }
  }, [])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleNext = () => {
    dispatch(updateLoanData(formData))
    history.push('/refiApp/financing/apply/residence-details')
  }

  const handleBack = () => {
    history.push('/refiApp/financing/apply/ownership')
  }

  const handleSkip = () => {
    history.push('/refiApp/financing/apply/residence-details')
  }

  return (
    <div className="applicant-info-component" style={{ maxWidth: '540px', margin: '0 auto', padding: '20px' }}>
      <div className="loan-form">
        <div className="loan-form__header">
          <h1 className="loan-form__title">Tell us a bit about your loan</h1>
          <p className="loan-form__description">
            {user?.firstName || 'Hi'}, we will use this to recommend payment options for affording coverage protecting your vehicle.
          </p>
        </div>

        <div className="loan-form__fields">
          <div className="form__section">
            <label htmlFor="monthlyPayment" className="form__label">
              Monthly Payment
            </label>
            <input
              id="monthlyPayment"
              name="monthlyPayment"
              type="text"
              value={formData.monthlyPayment}
              onChange={handleInputChange}
              placeholder="example: $123.00"
              className="form__input form__input--full-width"
            />
          </div>

          <div className="form__section">
            <label htmlFor="currentLender" className="form__label">
              Current Lender
            </label>
            <input
              id="currentLender"
              name="currentLender"
              type="text"
              value={formData.currentLender}
              onChange={handleInputChange}
              placeholder="example: Ally Finance"
              className="form__input form__input--full-width"
            />
          </div>

          <div className="form__section">
            <label htmlFor="estimatedPayoff" className="form__label">
              Estimated Payoff
            </label>
            <input
              id="estimatedPayoff"
              name="estimatedPayoff"
              type="text"
              value={formData.estimatedPayoff}
              onChange={handleInputChange}
              placeholder="example: $11,250"
              className="form__input form__input--full-width"
            />
          </div>
        </div>

        <div className="loan-form__actions">
          <button
            type="button"
            onClick={handleNext}
            className="button button--primary button--full-width"
          >
            Next
          </button>
        </div>

        <div className="loan-form__navigation" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
          <button
            type="button"
            onClick={handleBack}
            className="button button--link-text"
          >
            Back
          </button>
          <button
            type="button"
            onClick={handleSkip}
            className="button button--link-text"
          >
            Skip
          </button>
        </div>
      </div>
    </div>
  )
}

ApplicantInfoComponent.displayName = 'Applicant Info Component'

export default ApplicantInfoComponent